import { configureStore } from '@reduxjs/toolkit';
import productReducer from './getProductSlice';

export const store = configureStore({
    reducer: {
        product: productReducer,
    },
});

export default store;
